import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import createPersistedState from 'vuex-persistedstate';

import app from '@/store/modules/app';

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';

// NOTICE: 这里如果修改成了 localStorage 则
// 退出登录，或者进行页面切换的时候需要手动的进行清理
const plugins = [
    createPersistedState({
        storage: window.localStorage,
    }),
];
if (debug) {
    plugins.push(createLogger());
}

export default new Vuex.Store({
    plugins,
    modules: {
        app,
    },
});
